import axios from 'axios'
import router from '../router/index'
// 超时时间
axios.defaults.timeout = 30000

// http请求拦截器
axios.interceptors.request.use(
  config => {
    config.data = JSON.stringify(config.data)
    config.headers = {
      'Content-Type': 'application/json; charset=UTF-8',
      'token' : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE1OTA3ODE5MTIsInN1YiI6IntcIklkXCI6XCIyXCJ9In0.B0RFThLe6Hm5WKU6GMaHS_Jp4Rf1J2h8o8dtOGEdrg8'
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// http响应拦截器
axios.interceptors.response.use(
  data => {
    return data.data
  },
  error => {

    return Promise.reject(error)
  }
)

let http = {
    get(url,params){
        return new Promise((resolve,reject) =>{
            axios.get(url,params).then((response)=>{
                resolve(response)
            }).catch((err)=>{
                reject(err)
            })
        })
    },
    post(url,params){
        return new Promise((resolve,reject) =>{
            axios.post(url,params).then((response)=>{
                resolve(response)
            }).catch((err)=>{
                reject(err)
            })
        })
    }
}
export default http


// WEBPACK FOOTER //
// ./src/httpConfig/index.js